'use client'

import { useState } from 'react'

import { BillingPeriod, useBillingPeriodData } from '@/components/ReservationContext'

import { getPeriodLabel } from './lib/period-utils'
import { BillingAuthForm } from './ui/BillingAuthForm'
import { BillingChartWithControls } from './ui/BillingChartWithControls'
import { BillingStatsCards } from './ui/BillingStatsCards'
import { LoadingSpinner } from './ui/LoadingSpinner'

export default function BillingPage() {
    const [selectedPeriod, setSelectedPeriod] = useState<BillingPeriod>('daily')
    const [selectedDate, setSelectedDate] = useState<Date>(new Date())
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    const { billingData, stats, isLoading } = useBillingPeriodData(selectedDate, selectedPeriod)

    const handleAuthentication = () => {
        setIsAuthenticated(true)
    }

    const handlePeriodChange = (period: string) => {
        setSelectedPeriod(period as BillingPeriod)
    }

    const handleDateChange = (date: Date | undefined) => {
        if (date) {
            setSelectedDate(date)
        }
    }

    if (!isAuthenticated) {
        return <BillingAuthForm onAuthenticated={handleAuthentication} />
    }

    if (isLoading) {
        return <LoadingSpinner />
    }

    const periodLabel = getPeriodLabel(selectedDate, selectedPeriod)

    return (
        <div className='container mx-auto space-y-6 p-6'>
            <div className='flex items-center justify-between'>
                <h1 className='text-3xl font-bold'>Facturación</h1>
            </div>

            <BillingStatsCards stats={stats} />

            <BillingChartWithControls
                billingData={billingData}
                periodLabel={periodLabel}
                selectedDate={selectedDate}
                selectedPeriod={selectedPeriod}
                onDateChange={handleDateChange}
                onPeriodChange={handlePeriodChange}
            />
        </div>
    )
}
